export default "__VITE_ASSET__B8tyqWyb__"